<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    {{data.message}}
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button (click)=onCancel()>Close</button>
    <button mat-raised-button style="color: white;" (click)=onConfirm() color="primary">Confirm</button>
</div>